'use strict';

var _index = require('../../index');

var _index2 = _interopRequireDefault(_index);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _express = require('express');

var _express2 = _interopRequireDefault(_express);

var _cookieParser = require('cookie-parser');

var _cookieParser2 = _interopRequireDefault(_cookieParser);

var _bodyParser = require('body-parser');

var _bodyParser2 = _interopRequireDefault(_bodyParser);

var _IndexRoute = require('./IndexRoute');

var _IndexRoute2 = _interopRequireDefault(_IndexRoute);

var _StaticRoute = require('./StaticRoute');

var _StaticRoute2 = _interopRequireDefault(_StaticRoute);

var _ErrorHandlingRoute = require('./ErrorHandlingRoute');

var _ErrorHandlingRoute2 = _interopRequireDefault(_ErrorHandlingRoute);

var _PluginRestServiceExtensionHandler = require('./PluginRestServiceExtensionHandler');

var _PluginRestServiceExtensionHandler2 = _interopRequireDefault(_PluginRestServiceExtensionHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = (0, _express2.default)();
app.engine('html', require('express-art-template'));
app.set('view engine', 'html');
app.set('views', _path2.default.resolve('./views'));
app.set('view options', {
    debug: true
});

app.use(_bodyParser2.default.json());
app.use(_bodyParser2.default.urlencoded({ extended: false }));
app.use((0, _cookieParser2.default)());

var minima = new _index2.default(_path2.default.join(__dirname, 'plugins'));
minima.addService('app', app);
minima.start();

minima.addService("pluginRestServiceExtensions", new _PluginRestServiceExtensionHandler2.default(minima, app));

new _StaticRoute2.default(minima, app);
new _IndexRoute2.default(minima, app);
// The last routes for express, used to error handling.
new _ErrorHandlingRoute2.default(app);

module.exports = app;

app.listen(3001);
//# sourceMappingURL=index.js.map